export default "__VITE_ASSET__mAxQn9Q9__"